// adapted from: https://git.hubteam.com/HubSpot/conversations-internal-schema/blob/24c061ac8fe4f3aee9b0a5f69a2d760a19563fd5/static/js/routing-rules/operators/routingRulesGetters.js
import getIn from 'transmute/getIn';
import { BOT_ID, FALLBACK, ROTATION_METHOD, TEAM_IDS, TYPE, USER_IDS } from '../constants/keyPaths';
export const getBotId = getIn(BOT_ID);
export const getFallback = getIn(FALLBACK);
export const getRotationMethod = getIn(ROTATION_METHOD);
export const getTeamIds = getIn(TEAM_IDS);
export const getType = getIn(TYPE);
export const getUserIds = getIn(USER_IDS);